import { useEffect } from 'react';

import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { landingDataSelector } from 'store/page/selectors';
import { setLandingDataThunk } from 'store/page/thunks';

export function useInlineEditor(mockData) {
  const dispatch = useDispatch();
  const landingData = useSelector(landingDataSelector);

  useEffect(() => {
    if (landingData?.pages?.[0]?.blocks?.length === 0) {
      const lens = R.lensPath(['pages', 0]);
      const newData = R.set(lens, { ...landingData.pages[0], ...mockData }, landingData);
      dispatch(setLandingDataThunk(newData, { isLocalUpdate: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    landingData,
  };
}
